import React, { useState } from "react";
import { DashboardNav } from "../components/dashboard-nav";
import Logo from "../components/logo";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../Login/firebase";
import { Toaster } from "react-hot-toast";

import DashboardLive from "./Live/DashboardLive";
export default function DashboardLayout({children}) {
  const [user] = useAuthState(auth);
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const email = user && user.email;
  // console.log("user", email);

  
  return (
    <div className="relative flex   min-h-screen w-full ">
      {/* Dashboard Side Bar  */}
      {user && (
        <DashboardNav isExpanded={isExpanded} toggleExpand={toggleExpand} />
      )}
      {/* <div className="sticky top-0 hidden md:flex col-span-2 h-screen bg-black  ">
        <aside className=" max-h-screen  w-[260px] flex-col md:flex space-y-4 py-2 bg-black border-r-[1px] border-[#454646]/40">
          <div className=" px-4 w-full py-3">
            <Logo />
          </div>
          <DashboardNav />
        </aside>
      </div> */}
      <div className="sticky top-0 z-50 md:hidden flex h-[60px] bg-gray-900 "></div>

      {/* Main Dashboard  */}
      <main className={` w-full flex flex-1 md:flex min-h-full bg-black overflow-auto `}>
         {children}
      </main>
      <Toaster  position="bottom-right" reverseOrder={true} />
    </div>
  );
}
